import { makeValidationOfInputField } from './make-validation-of-input-field';
import { makeViewOfDisplayProperties } from './make-view-of-display-properties';
import { makeViewOfInputField } from './make-view-of-input-field';
export function transformFieldToV1(field) {
  return {
    id: field.id,
    hidden: field.hidden,
    ...resolveRootProperties(field)
  };
}
function resolveRootProperties(field) {
  if (field.inputOptions) {
    return {
      pii: field.inputOptions.pii,
      target: field.inputOptions.target,
      readOnly: field.inputOptions.readOnly,
      view: {
        fieldType: field.identifier,
        ...makeViewOfInputField(field.inputOptions)
      },
      validation: makeValidationOfInputField(field.inputOptions)
    };
  }
  if (field.displayOptions) {
    return {
      view: {
        fieldType: field.identifier,
        ...makeViewOfDisplayProperties(field.displayOptions)
      }
    };
  }
  return {};
}
//# sourceMappingURL=transform-field-to-v1.js.map